import React from "react";
var __jsx = React.createElement;
import loadable from "@loadable/component";
import { Fragment, useState } from "react";
import LoadMoreBtn from "../LoadMoreBtn/LoadMoreBtn";
import useIsMobile from "@hooks/useIsMobile";
import stl from "./UnbxdCards.module.css";
import { getLoaderBoxesCount, getWhenToShowUSPsRow__perDevice, isAutosScreen, isYearsScreen } from "@/pages/search/searchHooks/filtersHelpers";
import useDetectDeviceByMediaQuery from "@hooks/useDetectDeviceByMediaQuery";
import { CarCardPlaceHolderGrid } from "@componentsShared/placeholders/CarCardPlaceHolder";
import WithVisibilityTrigger from "@/common/HOCs/WithVisibilityTrigger";
import useKeyPressSwitch from "@hooks/useKeyPressSwitch";
import { useLocation } from "react-router-dom";
import useFilterPage, { useSearchResultsData } from "@/pages/search/searchHooks/useSearchAndFilters";
import ModernCard from "../../ModernCard/ModernCard";
import EligibilityComponent from "@/_MiniApps/EligibilityComponent/EligibilityComponent";
import MarketingBanner from "@/components/SearchComponent/NewComponents/MarketingBanner/MarketingBanner";
import { thumbUrl } from "@/utils/imagesHelpers";
import { useSearchUsps } from "@/components/SearchComponent/UnbxdComponents/SearchUsps/SearchUspsContext";
import Container from "@/components/sharedComponents/container/Container";
var fallback = {
  fallback: null
};
var BottomSheetPopup = loadable({
  resolved: {},
  chunkName: function chunkName() {
    return "componentsShared-BottomSheetPopup__OLD-BottomSheetPopup";
  },
  isReady: function isReady(props) {
    var key = this.resolve(props);
    if (this.resolved[key] !== true) {
      return false;
    }
    if (typeof __webpack_modules__ !== 'undefined') {
      return !!__webpack_modules__[key];
    }
    return false;
  },
  importAsync: function importAsync() {
    return import(/* webpackChunkName: "componentsShared-BottomSheetPopup__OLD-BottomSheetPopup" */"@componentsShared/BottomSheetPopup__OLD/BottomSheetPopup");
  },
  requireAsync: function requireAsync(props) {
    var _this = this;
    var key = this.resolve(props);
    this.resolved[key] = false;
    return this.importAsync(props).then(function (resolved) {
      _this.resolved[key] = true;
      return resolved;
    });
  },
  requireSync: function requireSync(props) {
    var id = this.resolve(props);
    if (typeof __webpack_require__ !== 'undefined') {
      return __webpack_require__(id);
    }
    return eval('module.require')(id);
  },
  resolve: function resolve() {
    if (require.resolveWeak) {
      return require.resolveWeak("@componentsShared/BottomSheetPopup__OLD/BottomSheetPopup");
    }
    return eval('require.resolve')("@componentsShared/BottomSheetPopup__OLD/BottomSheetPopup");
  }
}, fallback);
var GrantedPopup = loadable({
  resolved: {},
  chunkName: function chunkName() {
    return "NewComponents-GrantedPopup-GrantedPopup";
  },
  isReady: function isReady(props) {
    var key = this.resolve(props);
    if (this.resolved[key] !== true) {
      return false;
    }
    if (typeof __webpack_modules__ !== 'undefined') {
      return !!__webpack_modules__[key];
    }
    return false;
  },
  importAsync: function importAsync() {
    return import(/* webpackChunkName: "NewComponents-GrantedPopup-GrantedPopup" */"../../NewComponents/GrantedPopup/GrantedPopup");
  },
  requireAsync: function requireAsync(props) {
    var _this = this;
    var key = this.resolve(props);
    this.resolved[key] = false;
    return this.importAsync(props).then(function (resolved) {
      _this.resolved[key] = true;
      return resolved;
    });
  },
  requireSync: function requireSync(props) {
    var id = this.resolve(props);
    if (typeof __webpack_require__ !== 'undefined') {
      return __webpack_require__(id);
    }
    return eval('module.require')(id);
  },
  resolve: function resolve() {
    if (require.resolveWeak) {
      return require.resolveWeak("../../NewComponents/GrantedPopup/GrantedPopup");
    }
    return eval('require.resolve')("../../NewComponents/GrantedPopup/GrantedPopup");
  }
}, fallback);
var UnbxdCards = function UnbxdCards(_ref) {
  var loading = _ref.loading,
    posts = _ref.posts,
    usps = _ref.usps,
    metaData = _ref.metaData;
  var isMobile = useIsMobile();
  var _useState = useState(false),
    showGrantedPopup = _useState[0],
    setShowGrantedPopup = _useState[1];
  var device = useDetectDeviceByMediaQuery();
  var numberOfLoaders = getLoaderBoxesCount(device);
  var NUMBER_OF_POSTS = getWhenToShowUSPsRow__perDevice(device);
  var _useSearchResultsData = useSearchResultsData(),
    marketingBanner = _useSearchResultsData.marketingBanner;
  var _useFilterPage = useFilterPage(),
    hasMorePages = _useFilterPage.hasMorePages,
    runWhenElementViewed = _useFilterPage.runWhenElementViewed,
    page = _useFilterPage.page,
    isDealPage = _useFilterPage.isDealPage;
  var location = useLocation();
  var isAutoPage = isAutosScreen(location);
  var isYearsPage = isYearsScreen(location);
  var banner = marketingBanner === null || marketingBanner === void 0 ? void 0 : marketingBanner[isMobile ? "mobile" : "desktop"];
  var _useSearchUsps = useSearchUsps(),
    renderUsps = _useSearchUsps.renderUsps;
  var PostswithNoEligibilityCard = posts === null || posts === void 0 ? void 0 : posts.filter(function (post) {
    return !post.isEligibilityCard;
  });
  var postsToLoop = isMobile ? posts : PostswithNoEligibilityCard;
  var showLoadMoreButton = hasMorePages() && !loading;
  var _useState2 = useState(false),
    showOldCard = _useState2[0],
    setShowOldCard = _useState2[1];
  var handleKeyPressSwitch = function handleKeyPressSwitch() {
    setShowOldCard(!showOldCard);
  };
  useKeyPressSwitch(handleKeyPressSwitch);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement("div", {
    id: "posts-cards-grid",
    className: stl.allCarsResult
  }, !loading && isAutoPage && (postsToLoop || []).length !== 0 || !isAutoPage && !(loading && (postsToLoop || []).length === 0) ? /*#__PURE__*/React.createElement(React.Fragment, null, postsToLoop === null || postsToLoop === void 0 ? void 0 : postsToLoop.map(function (post, idx) {
    var isEager = isMobile ? idx === 0 : idx < 4;
    if (post.isEligibilityCard) return /*#__PURE__*/React.createElement(Fragment, {
      key: "eligibility-".concat(idx)
    }, /*#__PURE__*/React.createElement(EligibilityComponent, {
      design: "card",
      entryPoint: "listing_page",
      skipFlag: !isMobile
    }));
    return /*#__PURE__*/React.createElement(Fragment, {
      key: idx
    }, idx === 1 && (postsToLoop === null || postsToLoop === void 0 ? void 0 : postsToLoop.length) > 4 && isMobile && !isDealPage && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(MarketingBanner, {
      src: thumbUrl(banner, "hero-v1", isMobile ? "0x154" : "0x960"),
      progressiveSmallImage: thumbUrl(banner, "hero-v1", isMobile ? "0x99" : "0x154"),
      width: isMobile ? 351 : 1200,
      height: isMobile ? 119 : 187,
      marketingBanner: marketingBanner
    })), renderUsps(idx, isMobile), /*#__PURE__*/React.createElement(WithVisibilityTrigger, {
      cb: runWhenElementViewed,
      enabled: idx === (postsToLoop === null || postsToLoop === void 0 ? void 0 : postsToLoop.length) - 1 && !loading && hasMorePages() && !isAutoPage,
      once: false
    }, /*#__PURE__*/React.createElement(ModernCard, {
      post: post,
      isEager: isEager,
      showGrantedPopup: function showGrantedPopup() {
        return setShowGrantedPopup(true);
      },
      metaData: metaData,
      page: page,
      rank: idx + 1
    })));
  })) : null)), !isAutoPage && hasMorePages() && loading && /*#__PURE__*/React.createElement(Container, {
    className: "mt-3"
  }, /*#__PURE__*/React.createElement(CarCardPlaceHolderGrid, {
    columnWidth: 275,
    length: numberOfLoaders
  })), !isAutoPage && !hasMorePages() && loading && /*#__PURE__*/React.createElement(Container, {
    className: "mt-3"
  }, /*#__PURE__*/React.createElement(CarCardPlaceHolderGrid, {
    columnWidth: 275,
    length: numberOfLoaders
  })), (isAutoPage || isYearsPage) && loading && /*#__PURE__*/React.createElement(Container, {
    className: "mt-3"
  }, /*#__PURE__*/React.createElement(CarCardPlaceHolderGrid, {
    columnWidth: 275,
    length: 16
  })), showLoadMoreButton && !isAutoPage && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(LoadMoreBtn, {
    page: page,
    showPlaceHolder: !showLoadMoreButton
  })), /*#__PURE__*/React.createElement(BottomSheetPopup, {
    show: showGrantedPopup,
    onClose: function onClose() {
      return setShowGrantedPopup(false);
    }
  }, /*#__PURE__*/React.createElement(GrantedPopup, null)));
};
export default UnbxdCards;